/**
 * @alpha
 */
export var EncodingType;
(function (EncodingType) {
    EncodingType["UTF8"] = "utf8";
    EncodingType["Base64"] = "base64";
})(EncodingType || (EncodingType = {}));
//# sourceMappingURL=LocalStorageAdapter.js.map